<template>
  <div>
    <van-nav-bar
      :title="msgtitle"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-field
      v-model="msgcontent"
      rows="2"
      autosize
      readonly
      type="textarea"
      maxlength="500"
      show-word-limit
    />
    <van-divider content-position="right">{{sender+" -- "+insertMsgdate}}</van-divider>
  </div>
</template>

<script>
import { NavBar, Field, Divider } from "vant";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Divider.name]: Divider
  },
  data() {
    return {
      msgcontent:'',
      msgtitle: '',
      sender: '',
      insertMsgdate: ''
    };
  },
  mounted() {
    this.init();
  },
  computed: {},
  //
  methods: {
    onClickLeft() {
      this.$router.push({path: '/messageCenter'});
    },
    init() {
      var url = "/memberBusiness/information/"+this.$route.query.Uid+"/informationSelect";
      this.$axios.get(url).then((res) => {
        this.msgcontent = res.data.msgcontent
        this.msgtitle = res.data.title
        this.sender = res.data.username
        this.insertMsgdate = res.data.msgdate
      });
    },
  },
};
</script>

<style lang="less">
</style>
